import ROUTE_NAMES from "routes/routeNames";
import { ORDER_STATUS, ORDER_STATUS_GROUPS } from "utils/orderStatus";
import {
  SERVICE_CATEGORY,
  SERVICE_CATEGORY_SLUG,
  getServiceCategoryFromCategoryName,
  toServiceCategory,
} from "utils/serviceCategory";

/** Matches order-list filter options in `ORDER_STATUS_DATA`. */
export const DASHBOARD_ORDER_STATUS = {
  ALL: "-1",
  IN_PROGRESS: ORDER_STATUS_GROUPS.IN_PROGRESS,
  SUCCESSFUL: `${ORDER_STATUS.COMPLETED}`,
  CANCELLED: ORDER_STATUS_GROUPS.CANCELLED,
} as const;

export const buildOrderListPath = (
  orderStatus?: string,
  options?: { merchantId?: string; merchantName?: string },
) => {
  const params = new URLSearchParams();
  params.set("orderStatus", orderStatus ?? DASHBOARD_ORDER_STATUS.ALL);
  if (options?.merchantId) {
    params.set("merchantId", options.merchantId);
  }
  if (options?.merchantName) {
    params.set("merchantName", options.merchantName);
  }
  return `${ROUTE_NAMES.MAIN_ROUTES.ORDER}?${params.toString()}`;
};

export const buildFeedbackListPath = (type?: string) => {
  if (!type) return ROUTE_NAMES.MAIN_ROUTES.FEEDBACK;
  return `${ROUTE_NAMES.MAIN_ROUTES.FEEDBACK}?type=${encodeURIComponent(type)}`;
};

export const buildServiceListPath = (
  category?: SERVICE_CATEGORY | number | string | null,
) => {
  const base = ROUTE_NAMES.MAIN_ROUTES.SERVICE_MANAGEMENT;
  if (category === undefined || category === null || category === "") {
    return base;
  }
  if (typeof category === "string" && Number.isNaN(Number(category))) {
    const fromName = getServiceCategoryFromCategoryName(category);
    if (fromName === undefined || fromName === null) return base;
    return `${base}/${SERVICE_CATEGORY_SLUG[fromName]}`;
  }
  const resolved = toServiceCategory(category);
  return `${base}/${SERVICE_CATEGORY_SLUG[resolved]}`;
};

export const buildUserListPath = (
  tab:
    | "customers"
    | "franchises"
    | "coordinators"
    | "service-partners" = "customers",
) => `${ROUTE_NAMES.MAIN_ROUTES.USER_MANAGEMENT.BASE}/${tab}`;
